module.exports = __webpack_public_path__ + "static/404-9f29983dc36e0ffefc627c3df3a830b2.png";